<template>
  <div class="auth-error-container">
    <div class="error-content">
      <div class="error-icon">
        <i class="el-icon-warning"></i>
      </div>
      <h1 class="error-title">Token验证失败</h1>
      <p class="error-message">{{ errorMessage }}</p>
      <div class="error-actions">
        <button class="retry-btn" @click="retryAuth">重新验证</button>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthError",
  computed: {
    errorMessage() {
      const storeError = this.$store.state.error;
      const fallbackMessage = '认证失败,请检查URL参数是否正确';
      return storeError || fallbackMessage;
    }
  },
  methods: {
    retryAuth() {
      this.$store.dispatch("initAuth").then(success => {
        if (success) {
          this.$router.push("/home")
        }
      })
    },
    contactSupport() {
      alert("请联系系统管理员获取正确的访问链接")
    }
  }
}
</script>

<style scoped>
.auth-error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.error-content {
  background: white;
  border-radius: 12px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}

.error-icon {
  font-size: 80px;
  color: #f56c6c;
  margin-bottom: 20px;
}

.error-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 16px;
  font-weight: 600;
}

.error-message {
  font-size: 16px;
  color: #666;
  margin-bottom: 32px;
  line-height: 1.6;
}

.error-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.retry-btn, .contact-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.retry-btn {
  background: #409eff;
  color: white;
}

.retry-btn:hover {
  background: #66b1ff;
}

.contact-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}

.contact-btn:hover {
  background: #e8e8e8;
}

@media (max-width: 480px) {
  .error-content {
    padding: 40px 20px;
  }
  
  .error-title {
    font-size: 24px;
  }
  
  .error-actions {
    flex-direction: column;
  }
  
  .retry-btn, .contact-btn {
    width: 100%;
  }
}
</style>
